/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
/**
 * `entities/asset-approval-chain` TanStack Query key factory.
 *
 * Keys are namespaced under `['project', projectId, 'asset-approval-chain', assetId]`
 * so a mutation can invalidate a single asset's assignment without touching the
 * `['project', projectId, 'approval-chains']` definition caches (those live in
 * `entities/approval-chain`).
 */

export const ASSET_APPROVAL_CHAIN_QUERY_KEYS = {
  /**
   * Prefix covering every asset's assignment within a project — used by bulk
   * mutations to refresh all open asset-approval-chain queries at once.
   */
  namespace: (projectId: string) => ['project', projectId, 'asset-approval-chain'] as const,
  /** An asset's approval-chain assignment + approval progress. */
  detail: (projectId: string, assetId: string) =>
    ['project', projectId, 'asset-approval-chain', assetId] as const,
} as const;
